import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useHistory } from 'react-router-dom';

const MyBeforePublications = () => {
  const [publications, setPublications] = useState([]);
  const history = useHistory();

  const claimedId = sessionStorage.getItem('userId') || 'U001'; // Fallback
  const handleViewYourss = () => {

    history.push('/r');
  };
  useEffect(() => {
    const fetchPublications = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/beforepublications/by-claimed/${claimedId}`);
        setPublications(response.data);
      } catch (error) {
        console.error('Error fetching publications:', error);
      }
    };

    fetchPublications();
  }, [claimedId]);

  const getStatusText = (status) => {
    if (status === '1') return 'Approved';
    if (status === '2') return 'Rejected';
    return 'Not Approved';
  };

  const handleEdit = (id) => {
    history.push(`/beforepublication/edit/${id}`);
  };

  return (
    <div className="container mt-4">
       <h6
        className="p-2 text-center border rounded text-light"
        style={{
          cursor: 'pointer',
          width: '400px',
          height:"35px",
          textAlign: 'center',
          backgroundColor: 'var(--bs-primary)', // Bootstrap primary color
          transition: 'background-color 0.3s, color 0.3s', // Smooth transition
        }}
        onMouseEnter={(e) => {
          e.target.style.backgroundColor = '#004085'; // Gray color on hover
          e.target.style.color = 'white'; // Ensure text remains readable
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor = 'var(--bs-primary)'; // Original background
          e.target.style.color = 'white'; // Original text color
        }}
        onClick={handleViewYourss}
      >
         Before Publication(Faculty)
      </h6>
      <h3 className="mb-4 text-primary text-center">My Before Publications</h3>
      <table className="table table-bordered table-hover">
        <thead className="table-dark">
          <tr>
            <th>ID</th>
            <th>Paper Title</th>
            <th>Journal</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {publications.map((pub) => (
            <tr key={pub.id}>
              <td>{pub.id}</td>
              <td>{pub.paperTitle}</td>
              <td>{pub.journalName}</td>
              <td className={
                pub.status === '1' ? 'text-success' :
                pub.status === '2' ? 'text-danger' :
                'text-warning'
              }>
                {getStatusText(pub.status)}
              </td>
              <td>
                {pub.status === '0' && (
                  <button className="btn btn-sm btn-warning me-2" onClick={() => handleEdit(pub.id)}>
                    Edit
                  </button>
                )}
                <button className="btn btn-sm btn-info" onClick={() => history.push(`/b/view/${pub.id}`)}>
                  View
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MyBeforePublications;
